export const useGetPolicyPageStyles = () => {
  return {
    page: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    },
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "960px",
      margin: "0 auto",
      padding: "24px 20px 40px",
      flex: 1,
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      marginBottom: "20px",
    },
    logo: {
      display: "flex",
      alignItems: "center",
    },
  };
};
